import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { ReceiverType } from "../../app/types/genericTables.types";

type UseReceiverType = {
  receiverList: ReceiverType[];
  get: (id: ReceiverType["id"]) => ReceiverType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useReceiver = create<UseReceiverType>((set, get) => ({
  loading: false,
  receiverList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().receiverList.find((receiver) => receiver.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/destinatarios";
      const { data: response } = await getData(endpoint);
      set(() => ({
        receiverList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useClient:", error);
      set({ loading: false });
    }
  },
}));
